const getImageBaseUrl = () =>
  process.env.REACT_APP_IMG_BASE_URL ? process.env.REACT_APP_IMG_BASE_URL : "";

export default getImageBaseUrl;
